import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController, ModalController, PopoverController } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { ListarOrdenesProcedimientosPage } from '../listar-ordenes-procedimientos/listar-ordenes-procedimientos.page'
import { ListarOrdenesMedicamentosPage } from '../listar-ordenes-medicamentos/listar-ordenes-medicamentos.page'

@Component({
  selector: 'app-opciones-hc-poppover',
  templateUrl: './opciones-hc-poppover.page.html',
  styleUrls: ['./opciones-hc-poppover.page.scss'],
})
export class OpcionesHcPoppoverPage implements OnInit {
  
  public Estudio;
  public TipoManual;
  public popoverCtrl;

  constructor(
    private route: ActivatedRoute,
    private router:Router) { 
   // this.Estudio = navParams.get('Estudio');
  }

  ngOnInit() {
  }

  nuevaOrdProcedimientos(){
    this.popoverCtrl.dismiss();  
    this.router.navigate(['/crear-orden-intrahospitalaria-pcto'],{queryParams: {Estudio:this.Estudio}});
    //this.navCtrl.push(CrearOrdenIntrahospitalariaPctoPage,{Estudio:this.Estudio});
  }

  nuevaOrdExtProcedimientos(){
    this.popoverCtrl.dismiss();  
    this.router.navigate(['/crear-orden-externa-pcto'],{queryParams: {Estudio:this.Estudio}});
  }

  nuevaOrdMedicamentos(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/crear-orden-intrahospitalaria-mcto'],{queryParams: {Estudio:this.Estudio,TipoManual: this.TipoManual}});
//    this.navCtrl.push(CrearOrdenIntrahospitalariaMctoPage,{Estudio:this.Estudio});
  }
  
  nuevaOrdExtMedicamentos(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/crear-orden-externa-mcto'],{queryParams: {Estudio:this.Estudio,TipoManual: this.TipoManual}});
  }

  listarOrdMedicamentos(){
    this.popoverCtrl.dismiss();    
//    this.navCtrl.push(ListarOrdenesMedicamentosPage,{Estudio:this.Estudio});
    this.router.navigate(['/listar-ordenes-medicamentos'],{queryParams: {Estudio:this.Estudio}});
  }

  listarOrdProcedimientos(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/listar-ordenes-procedimientos'],{queryParams: {Estudio:this.Estudio}});
  //this.navCtrl.push(ListarOrdenesProcedimientosPage,{Estudio:this.Estudio});
  }

  listarOrdExternaProcedimientos(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/listar-ordenes-externas-pcto'],{queryParams: {Estudio:this.Estudio}});
  }

  listarOrdExternaMedicamentos(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/listar-ordenes-externas-mcto'],{queryParams: {Estudio:this.Estudio}});
  }

  listarDocFirmados(){
    this.popoverCtrl.dismiss();    
    this.router.navigate(['/listar-documentos-firmados'],{queryParams: {Estudio:this.Estudio}});
  //this.navCtrl.push(ListarOrdenesProcedimientosPage,{Estudio:this.Estudio});
  }

}
